import cmmnRoutes from "@/router/items/CmmnRoutes";
import guideRoutes from "@/router/items/GuideRoutes"; // 가이드
import systemRoutes from "@/router/items/SystemRoutes"; // 시스템 관리
import communityRoutes from "./CommunityRoutes";
import diagRoutes from "./DiagRoutes";
import ecpRoutes from "./EcpRoutes";
import statisticRoutes from "./StatisticRoutes";
import stdInfoRoutes from "./StdInfoRoutes";

const adminRoutes = [
  {
    path: "",
    name: "admin",
    redirect: { name: "login" },
    component: () => import("@/layout/LayoutAdmin.vue"),
    children: [
      {
        path: "main",
        component: () => import("@/views/main/AdminMain.vue"),
      },
      ...guideRoutes, // 가이드
      ...systemRoutes, // 시스템 관리
      ...stdInfoRoutes, // 학생 정보 조회
      ...ecpRoutes, // 비교과
      ...diagRoutes, // 진단 관리
      ...communityRoutes, // 커뮤니티
      ...statisticRoutes, // 통계 > 비교과 프로그램 통계
    ],
  },
  {
    path: "/onlyDainIndex",
    name: "onlyDainIndex",
    meta: {
      title: "로그인",
      noCrumb: true,
      isDynamic: false,
    },
    component: () => import("@/views/login/AdminLogin.vue"),
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: "로그인",
      noCrumb: true,
      isDynamic: false,
    },
    component: () => import("@/views/login/AdminLogin.vue"),
  },
  ...cmmnRoutes, // 공통 라우트
];

export default adminRoutes;
